export default "__VITE_ASSET__DrkZ6oOb__"